module.exports = __webpack_public_path__ + "static/media/FJ.49f9fa66.svg";